export type BlinkCondition = {
    category: number;
};

export type Blink = Record<number, BlinkCondition>;

export const blink: Blink = {
    1: { category: 1 },
    2: { category: 1 },
    3: { category: 4 },
    4: { category: 1 },
    5: { category: 1 },
    6: { category: 2 },
    7: { category: 2 },
    11: { category: 2048 },
    12: { category: 2048 },
    13: { category: 2048 },
    14: { category: 2048 },
    15: { category: 2048 },
    21: { category: 8191 },
    30: { category: 8191 },
    31: { category: 8191 },
    32: { category: 8191 },
    33: { category: 8191 },
    64: { category: 8191 },
    66: { category: 8191 },
    68: { category: 8191 },
    72: { category: 8191 },
    74: { category: 8191 }
};

export const blinkLC600: Blink = {
    225: { category: 8191 },
    239: { category: 8191 },
    240: { category: 8191 },
    241: { category: 8191 },
    242: { category: 8191 },
    243: { category: 8191 },
    244: { category: 8191 },
    245: { category: 8191 },
    246: { category: 8191 },
    247: { category: 8191 },
    248: { category: 8191 },
    264: { category: 8191 },
    267: { category: 8191 },
    268: { category: 8191 },
    273: { category: 8191 }
};